
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/markhopalistar",
      function () {
        return require("private-next-pages/um/thjonusta/markhopalistar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/markhopalistar"])
      });
    }
  